import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import {Store} from "@ngrx/store";
import {AppState} from "../../../../state";
import {downloadInterventionAnswers} from '../../../state/metrics/metrics.actions';



@Component({
  selector: 'dashboard-metrics-download-dialog',
  templateUrl: './metrics-download-dialog.component.html',
  styleUrls: ['./metrics-download-dialog.component.scss'],
})
export class MetricsDownloadDialogComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: { intervention: any; code: any; },
    private store: Store<AppState>
  ) {
  }

  ngOnInit(): void {
  }

  downloadVersionQP(): void {
    this.store.dispatch(
      downloadInterventionAnswers({
        languageCode: this.data?.code,
        interventionId: this.data?.intervention?.id,
        version: 'module_headers',
      })
    );
  }

  downloadVersionPQ(): void {
    this.store.dispatch(
      downloadInterventionAnswers({
        languageCode: this.data?.code,
        interventionId: this.data?.intervention?.id,
        version: 'participant_headers',
      })
    );
  }
}
